import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import TotalPassDetalle from "../../types/TotalPassDetalle";
import { readMessageBack } from "../../utils/readMessageBack";
import { PaymentMovement } from "../components/paymentMovements";

export interface GetTotalPassList {
  totalPassList: Page<TotalPassDetalle>;
  gettingTotalPassList: boolean;
  gettingTotalPassListError: string;
}
export interface GetTotalPass {
  totalPass: TotalPassDetalle;
  gettingTotalPass: boolean;
  gettingTotalPassError: string;
}
export interface GetMovimientosTotalPass {
  movimientosTotalPass: PaymentMovement[];
  gettingMovimientosTotalPass: boolean;
  gettingMovimientosTotalPassError: string;
}
export interface GetBitacoraTotalPass {
  bitacoraTotalPass: any[];
  gettingBitacoraTotalPass: boolean;
  gettingBitacoraTotalPassError: string;
}
export interface GetClubesAccesoTotalPass {
  clubesAccesoTotalPass: any[];
  gettingClubesAccesoTotalPass: boolean;
  gettingClubesAccesoTotalPassError: string;
}

export interface DeleteBajaAppTotalPass {
  bajaAppResult: any;
  postingBajaApp: boolean;
  postingBajaAppError: string;
}

interface State
  extends GetTotalPassList,
    GetTotalPass,
    GetMovimientosTotalPass,
    GetClubesAccesoTotalPass,
    GetBitacoraTotalPass,
    DeleteBajaAppTotalPass {}

const initialState: State = {
  totalPassList: null,
  gettingTotalPassList: false,
  gettingTotalPassListError: null,

  totalPass: null,
  gettingTotalPass: false,
  gettingTotalPassError: null,

  movimientosTotalPass: null,
  gettingMovimientosTotalPass: false,
  gettingMovimientosTotalPassError: null,

  bitacoraTotalPass: null,
  gettingBitacoraTotalPass: false,
  gettingBitacoraTotalPassError: null,

  clubesAccesoTotalPass: null,
  gettingClubesAccesoTotalPass: false,
  gettingClubesAccesoTotalPassError: null,

  bajaAppResult: null,
  postingBajaApp: false,
  postingBajaAppError: null
};

export default function totalPassReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  // Llamada a resolver de snapshot
  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(
  state: State = initialState,
  action: IAction
): Partial<State> {
  switch (action.type) {
    // CLEAR_TOTAL_PASS_LIST
    case actionTypes.CLEAR_TOTAL_PASS_LIST: {
      return {
        totalPassList: null
      };
    }

    // GET_TOTAL_PASS
    case `${actionTypes.GET_TOTAL_PASS_LIST}_PENDING`: {
      return {
        gettingTotalPassList: true,
        gettingTotalPassListError: null
      };
    }
    case `${actionTypes.GET_TOTAL_PASS_LIST}_REJECTED`: {
      return {
        totalPassList: null,
        gettingTotalPassList: false,
        gettingTotalPassListError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_TOTAL_PASS_LIST}_FULFILLED`: {
      return {
        totalPassList: action.payload.data,
        gettingTotalPassList: false,
        gettingTotalPassListError: null
      };
    }

    // CLEAR_TOTAL_PASS
    case actionTypes.CLEAR_TOTAL_PASS: {
      return {
        totalPass: null
      };
    }

    // GET_TOTAL_PASS
    case `${actionTypes.GET_TOTAL_PASS}_PENDING`: {
      return {
        gettingTotalPass: true,
        gettingTotalPassError: null
      };
    }
    case `${actionTypes.GET_TOTAL_PASS}_REJECTED`: {
      return {
        totalPass: null,
        gettingTotalPass: false,
        gettingTotalPassError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_TOTAL_PASS}_FULFILLED`: {
      return {
        totalPass: action.payload.data,
        gettingTotalPass: false,
        gettingTotalPassError: null
      };
    }

    // CLEAR_MOVIMIENTOS_TOTAL_PASS
    case actionTypes.CLEAR_MOVIMIENTOS_TOTAL_PASS: {
      return {
        movimientosTotalPass: null
      };
    }

    // GET_MOVIMIENTOS_TOTAL_PASS
    case `${actionTypes.GET_MOVIMIENTOS_TOTAL_PASS}_PENDING`: {
      return {
        gettingMovimientosTotalPass: true,
        gettingMovimientosTotalPassError: null
      };
    }
    case `${actionTypes.GET_MOVIMIENTOS_TOTAL_PASS}_REJECTED`: {
      return {
        movimientosTotalPass: null,
        gettingMovimientosTotalPass: false,
        gettingMovimientosTotalPassError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_MOVIMIENTOS_TOTAL_PASS}_FULFILLED`: {
      return {
        movimientosTotalPass: action.payload.data,
        gettingMovimientosTotalPass: false,
        gettingMovimientosTotalPassError: null
      };
    }

    // CLEAR_BITACORA_TOTAL_PASS
    case actionTypes.CLEAR_BITACORA_TOTAL_PASS: {
      return {
        bitacoraTotalPass: null
      };
    }

    // GET_BITACORA_TOTAL_PASS
    case `${actionTypes.GET_BITACORA_TOTAL_PASS}_PENDING`: {
      return {
        gettingBitacoraTotalPass: true,
        gettingBitacoraTotalPassError: null
      };
    }
    case `${actionTypes.GET_BITACORA_TOTAL_PASS}_REJECTED`: {
      return {
        bitacoraTotalPass: null,
        gettingBitacoraTotalPass: false,
        gettingBitacoraTotalPassError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_BITACORA_TOTAL_PASS}_FULFILLED`: {
      return {
        bitacoraTotalPass: action.payload.data,
        gettingBitacoraTotalPass: false,
        gettingBitacoraTotalPassError: null
      };
    }

    // GET CLUBES ACCESO TOTAL_PASS
    case `${actionTypes.GET_CLUBES_ACCESO_TOTAL_PASS}_PENDING`: {
      return {
        gettingClubesAccesoTotalPass: true,
        gettingClubesAccesoTotalPassError: null
      };
    }
    case `${actionTypes.GET_CLUBES_ACCESO_TOTAL_PASS}_REJECTED`: {
      return {
        clubesAccesoTotalPass: null,
        gettingClubesAccesoTotalPass: false,
        gettingClubesAccesoTotalPassError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_CLUBES_ACCESO_TOTAL_PASS}_FULFILLED`: {
      return {
        clubesAccesoTotalPass: action.payload.data,
        gettingClubesAccesoTotalPass: false,
        gettingClubesAccesoTotalPassError: null
      };
    }

    // DELETE_TOTAL_PASS_BAJA_APP (/total-pass/baja-app)
    case `${actionTypes.DELETE_TOTAL_PASS_BAJA_APP}_PENDING`: {
      return {
        postingBajaApp: true,
        postingBajaAppError: null,
        bajaAppResult: null
      };
    }
    case `${actionTypes.DELETE_TOTAL_PASS_BAJA_APP}_REJECTED`: {
      return {
        postingBajaApp: false,
        postingBajaAppError: readMessageBack(action),
        bajaAppResult: null
      };
    }
    case `${actionTypes.DELETE_TOTAL_PASS_BAJA_APP}_FULFILLED`: {
      const data = action.payload && action.payload.data;
      const result =
        data && data.body !== undefined
          ? {
              ...data.body,
              message: data.message || (data.body && data.body.message)
            }
          : data;
      return {
        postingBajaApp: false,
        postingBajaAppError: null,
        bajaAppResult: result
      };
    }

    default: {
      return state;
    }
  }
}
